import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import CVposter from '../Media/CVposter.pdf'
import V1504 from '../Media/v1504_v0.4.pdf'
import V344 from '../Media/FinalPaper.pdf'



class Projects extends React.Component {

    render() {
        return (
            <div className='home'>

                <h2>Time-Domain Analysis of Cataclysmic Variables</h2>
                <p>
                As an undergraduate, I performed time series analysis on Kepler observations of 3 cataclysmic variables. I used a Fast Fourier Transform and sine-fitting to look for the orbital period. We found that the super-outburst behavior of SU UMa type variables causes a change in the observed period, and that our 2 SU UMa type variables both exhibited 3 characteristic periods, known previously to exist only in other types of cataclysmic variables due to apsidal and nodal precessions of the accretion disk with respect to the secondary star. This work resulted in a poster (see figure), as well as my undergraduate thesis and a submitted manuscript.
</p>

 <img className='img-rounded' alt='CVposter' src={CVposter} style={{height:'auto',width:'100%'}}></img>

  <p>
</p>

<Button href={V344} target="_blank">V344 Lyra</Button>
  <p>
</p>
<Button href={V1504} target="_blank">V1504 Cygnus</Button>

            </div>
        );
    }
}

const styles = theme => ({
  root: {
    maxWidth: 400,
    flexGrow: 1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    paddingLeft: theme.spacing.unit * 4,
    backgroundColor: theme.palette.background.default,
  },
  img: {
    display: 'block',
    overflow: 'hidden',
    width: '100%',
  },
});

Projects.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Projects);



// WEBPACK FOOTER //
// ./src/Components/BinaryStars.js